import getHtmlClassByHint from '../lib/get-html-class';

const widgetFineuploader = () => {
  if(!document.querySelector('.widget-fineuploader')) {
    return;
  }
  
  const widget = document.querySelector('.widget-fineuploader');
  const button = widget.querySelector('.qq-upload-button');

  const getDesign = getHtmlClassByHint(widget, 'design-');
  const getSize = getHtmlClassByHint(widget, 'size-');

  button.classList.add('button');

  if(getDesign) {
    button.classList.add(getDesign);
  }

  if(getSize) {
    button.classList.add(getSize);
  }
}

export default widgetFineuploader;
